export default __webpack_public_path__ + "static/blog_logo-5b63da5a2840670f37b79a1f23cac1a1.png";